<template>
    <section class="chart-container">
        <el-row v-if="userRoleIdentity == 'level-untrue'">
            <el-col :span="24"  class="toolbar" style="padding-bottom: 10px;">
            <label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">选择项目:</label>
            <el-select  v-model="chartGroup" placeholder="请选择" style="width: 140px">
                <el-option v-for="i in demoChartTypeOpts" :label="i.name" :value="i.type"></el-option>
            </el-select>
            <el-button @click="queryBtn()">生成报表</el-button>
            </el-col>
            <el-col :span="24" style="padding-top: 2px;">
                <div id="alarmStageTotalChart" style="width:98%; height:360px;padding:12px 0px;"></div>
                <div id="alarmUnitAreaChart" style="width:98%; height:360px;padding:12px 0px;"></div>
                <div id="alarmSameTimeContrastChart" style="width:98%; height:360px;padding:12px 0px;"></div>
            </el-col>
        </el-row>
        <el-row v-else>
            <!--工具条-->
            <el-col :span="24"  class="toolbar" style="padding-bottom: 10px;">
                <el-tabs v-model="sysSourceOptName" @tab-click="tabHandleClick">
                    <!-- <el-tab-pane label="全部" name="all"></el-tab-pane> -->
                    <el-tab-pane v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-tab-pane>
                </el-tabs>
                <!-- <label v-if="sysSourceOptName == 'all'" style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">系统类型:</label>
                <el-select v-if="sysSourceOptName == 'all'" v-model="sysSourceOpt" placeholder="全部" style="width: 140px">
                    <el-option label="全部" value="all"></el-option>
                    <el-option v-for="i in sysSourceList" :label="i.name" :value="i.code"></el-option>
                </el-select> -->
                <label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">项目归属:</label>
                <el-input placeholder="请选择项目" suffix-icon="el-icon-date" style="width: 140px" @focus="showProjectTree"  v-model="projectNames"></el-input>			
                    <el-dialog title="项目归属" v-model="projectTreeDialogVisible" >
                    <div style="">
                        <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                        <el-tree class="filter-tree" :data="projectTree" show-checkbox node-key="id" :default-checked-keys="projectTreeDefaultChecked" :filter-node-method="filterNode" ref="projectTree"></el-tree>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="projectTreeOnCancel">取 消</el-button>
                        <el-button type="primary" @click="projectTreeOnSubmit">确 定</el-button>
                    </div>
                    </el-dialog>
                <label  style="width: 80px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">时间:</label>
                <div style="display:inline;">
                    <el-date-picker style="width:120px;" v-model="startMonth" value-format="yyyyMM" format="yyyyMM" type="month" :placeholder="startMonthValue" @change="startMonthOnChange"></el-date-picker>
                    <label  style="width: 40px; text-align: right;vertical-align: middle;font-size: 14px;color: grey;line-height: 1;padding: 10px 10px 10px 10px;box-sizing: border-box;">-</label>
                    <el-date-picker style="width:120px;" v-model="endMonth" value-format="yyyyMM" format="yyyyMM" type="month" :placeholder="endMonthValue" @change="endMonthOnChange"></el-date-picker>
                </div>
                <el-button @click="queryBtn()">生成报表</el-button>
            </el-col>
            <el-col :span="24" style="padding-top: 2px;">
                <div id="alarmStageTotalChart" style="width:98%; height:360px;padding:12px 0px;"></div>
                <div id="alarmUnitAreaChart" style="width:98%; height:360px;padding:12px 0px;"></div>
                <div id="alarmSameTimeContrastChart" style="width:98%; height:360px;padding:12px 0px;"></div>
            </el-col>
        </el-row>
    </section>
</template>

<script>
    import echarts from 'echarts'
    import api from '@/api';
    import tools from '@/util/tools';
    import global from '@/config/global_config'

    export default {
        data() {
            return {
                alarmStageTotalChart: null,
                alarmSameTimeContrastChart: null,
                alarmUnitAreaChart: null,
                sysSourceOptName:'',
				sysSourceList:[],
				sysSourceOpt:'',
				sysSourceTabSelected:'',
                projectTree:[],
                projectTreeDefaultChecked:[],
				filterText:'',
				projectTreeDialogVisible:false,
				projectTreeCheckedKeys:[],
				startMonth: '',
				endMonth:'',
                startMonthValue:tools.getCurrentYear()+'01',
				endMonthValue:tools.getCurrentYear()+'12',
                projectIds:'',
                projectIdsCount:0,
                projectsOpt:[],
                chartGroup:'c',//{a:单个项目,b:多个项目,c:全部业务组},
                projectNames:'',
                demoChartTypeOpts:[{"name":"单项目",type:"a"},{"name":"多项目",type:"b"},{"name":"全部项目",type:"c"}],
                chartTypeOpt:'c',
                userRoleIdentity:global.getCurrentUser().roleIdentity
            }
        },
        watch: {
			filterText(val) {
				this.$refs.projectTree.filter(val);
			}
        },
        methods: {
            filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
            },
			getProjectTree: function () {
				let param = {};
				this.listLoading = true;
				api.project_findByAccountIdList_request(param).then((res) => {
                    let temp = [];
                    let checkedTemp =[];
					 for (let index = 0; index < res.data.length; index++) {
                        checkedTemp.push(res.data[index].groupId);
						temp[index] = {id:res.data[index].groupId ,label:res.data[index].groupName,children:[]};
						res.data[index].projectList.forEach(one => {
                            checkedTemp.push(one.projectId);
                            temp[index].children.push({id:one.projectId,label:one.projectName});
                            this.projectIdsCount++;
						});
					}
                    this.projectTree = temp;
                    //this.projectTreeDefaultChecked = checkedTemp;
				}).catch(function (e) {
					console.log(e);
                });
				this.listLoading = false;
            },
            projectTreeOnCancel(){
				this.$refs.projectTree.setCheckedNodes([]);
				this.projectTreeDialogVisible = false;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let leafCheckedNodeNames = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children){
							leafCheckedNodes.push(one.id);
							leafCheckedNodeNames.push(one.label);
						}
					});
					console.log(leafCheckedNodeNames);
					this.projectNames = leafCheckedNodeNames.join(',');
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			startMonthOnChange(val) {  
				console.log(val);  
				this.startMonthValue = val;  
			},
			endMonthOnChange(val) {  
				console.log(val);  
				this.endMonthValue = val;
            },
            queryBtn(){
                if(this.userRoleIdentity == 'level-untrue'){
                    this.drawCharts();
                    return;
                }
                let projectNum = global.getCurrentUser().projectNum;
                if(this.projectIds){
                    let count = this.projectIds.split(',').length;
                    if(count == 1)this.chartGroup = 'a';
                    else if(count >1  && count< this.projectIdsCount) this.chartGroup = 'b';
                    else {
                        if((global.getCurrentUser().roleIdentity == 'admin') ||  (global.getCurrentUser().roleIdentity == 'level-untrue') || (global.getCurrentUser().roleIdentity == 'level-one'))this.chartGroup = 'c';
                        else this.chartGroup = 'b';
                    } 
                }
                else{
                    if(projectNum <= 0 ) {tools.error(this,"该账号下暂无项目");return;}
                    if(projectNum == 1)this.chartGroup = 'a';
                    else{
                        if((global.getCurrentUser().roleIdentity == 'admin') || (global.getCurrentUser().roleIdentity == 'level-untrue') || (global.getCurrentUser().roleIdentity == 'level-one'))this.chartGroup = 'c';
                        else this.chartGroup = 'b';
                    }
                    console.log(this.chartGroup);
                }
                console.log(this.chartGroup);
				this.drawCharts();
			},
            drawAlarmStageTotalChart(chartData) {
                if(document.getElementById('alarmStageTotalChart') == null) return;
                this.alarmStageTotalChart = echarts.init(document.getElementById('alarmStageTotalChart'));
                this.alarmStageTotalChart.clear();
                this.alarmStageTotalChart.setOption({
                    title: {
                        text: chartData.title,textStyle:{fontSize:12}
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: chartData.legend
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },    
                    xAxis: {
                        type: 'category',
                        data: chartData.xAxis,
                        axisLabel: {
                            interval:0,  
                            rotate:40
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: chartData.series,
                    color:chartData.color
                });
            },
			fetchCountAlarmReport: function () {
                let param;
                let chartData = {title:'',legend:[],xAxis:[],series:[],color:[]};
                if(this.sysSourceOpt == 'all') this.sysSourceOpt = '';
                let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
                if(this.chartGroup == 'a'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectId:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '单项目月度数据统计（条）';
                    chartData.color = ['#e01021'];
                    api.report_countAlarmReportAOne_request(param).then((res) => { 
                        if(res.data){
                            let seriesTemp = [];
                            for (let index = 0; index < res.data.length; index++) {
                                chartData.xAxis.push(res.data[index].alarmYm);
                                seriesTemp.push(res.data[index].countNum);
                            }
                            chartData.series.push({data:seriesTemp,type:'line'})
                        }                       
                        console.log(chartData);
					    this.drawAlarmStageTotalChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'b'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectIds:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '多项目月度数据统计（条）';
                    api.report_countAlarmReportBOne_request(param).then((res) => {   
                        if(res.data.dataArray){
                            let seriesTemp = [];
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].projectName);
                                seriesTemp.push(res.data.dataArray[index].countNum);
                            }
                            chartData.color.push('#e01021');
                            chartData.series.push({data:seriesTemp,type:'bar'});
                        } 
                        if(res.data.lastDataArray){
                            let seriesTemp = [];
                            for (let index = 0; index < res.data.lastDataArray.length; index++) {
                                seriesTemp.push(res.data.lastDataArray[index].countNum);
                            }
                            chartData.color.push('#b1b2b4');
                            chartData.series.push({data:seriesTemp,type:'bar'})
                        }
                        console.log(chartData);
					    this.drawAlarmStageTotalChart(chartData);
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'c'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '所有项目月度数据统计（条）';
                    chartData.color = ['#e01021'];
                    api.report_countAlarmReportCOne_request(param).then((res) => {   
                        if(res.data.dataArray){
                            let seriesTemp = [];
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].alarmYm);
                                seriesTemp.push(res.data.dataArray[index].countNum);
                            }
                            chartData.series.push({data:seriesTemp,type:'bar'})
                        } 
                        console.log(chartData);
					    this.drawAlarmStageTotalChart(chartData);
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
            },
            drawAlarmUnitAreaChart(chartData) {
                if(document.getElementById('alarmUnitAreaChart') == null) return;
                this.alarmUnitAreaChart = echarts.init(document.getElementById('alarmUnitAreaChart'));
                this.alarmUnitAreaChart.clear();
                this.alarmUnitAreaChart.setOption({
                    title: {
                        text: chartData.title,textStyle:{fontSize:12}
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:chartData.legend
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: chartData.xAxis,
                        axisLabel: {
                            interval:0,  
                            rotate:40
                        }
                    },
                    yAxis: {
                        type: 'value'
                    }, 
                    series: [
                        {
                            type: chartData.chartType,
                            data:chartData.series,
                            markLine : {
                                data : [
                                    //{type : 'average', name : '平均值',value:0.1}
                                    {name: '基准线',yAxis:chartData.baseLine},
                                ]
                            }
                        },
                    ],
                    color:['#e01021']
                });
            },
			fetchAlarmUnitAreaReport: function () {
                let param;
                let chartData = {title:'',legend:[],xAxis:[],series:[],chartType:'',baseLine:null};
                if(this.sysSourceOpt == 'all') this.sysSourceOpt = '';
                let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
                if(this.chartGroup == 'a'){  
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectId:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '单项目单位楼板面积数据统计（条/万平米）';
                    chartData.chartType = 'line';
                    api.report_countAlarmReportATwo_request(param).then((res) => {
                        if(res.data.dataArray){
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].alarmYm);
                                chartData.series.push(res.data.dataArray[index].countNum);
                            }
                        }                        

                        chartData.baseLine = res.data.baseLine;
                        console.log(chartData);
					    this.drawAlarmUnitAreaChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"单位面积告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'b'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectIds:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '多项目单位楼板面积数据统计（条/万平米）';
                    chartData.chartType = 'bar';
                    api.report_countAlarmReportBTwo_request(param).then((res) => {
                        if(res.data.dataArray){
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].projectName);
                                chartData.series.push(res.data.dataArray[index].countNum);
                            }
                        }                        
                        chartData.baseLine = res.data.baseLine;
                        console.log(chartData);
					    this.drawAlarmUnitAreaChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"单位面积告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'c'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '所有项目单位楼板面积数据统计（条/万平米）';
                    chartData.chartType = 'bar';
                    api.report_countAlarmReportCTwo_request(param).then((res) => { 
                        if(res.data.dataArray){
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].alarmYm);
                                chartData.series.push(res.data.dataArray[index].countNum);
                            }
                        }                       
                        chartData.baseLine = res.data.baseLine;
                        console.log(chartData);
					    this.drawAlarmUnitAreaChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"单位面积告警统计数据获取失败");
                    });
                }
            },
            drawAlarmSameTimeContrastChart(chartData) {
                if(document.getElementById('alarmSameTimeContrastChart') == null) return;
                this.alarmSameTimeContrastChart = echarts.init(document.getElementById('alarmSameTimeContrastChart'));
                this.alarmSameTimeContrastChart.clear();
                this.alarmSameTimeContrastChart.setOption({
                    title: {
                        text: chartData.title,textStyle:{fontSize:12}
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        data: chartData.legend
                    },
                    calculable : true,
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: chartData.xAxis,
                        axisLabel: {
                            interval:0,  
                            rotate:40
                        }
                    }, 
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            type: chartData.chartType,
                            data: chartData.series[0]
                        },
                        {
                            type: chartData.chartType,
                            data:chartData.series[1]
                        }
                    ],
                    color:['#e01021','#b1b2b4']
                });
            },
			fetchAlarmSameTimeContrastReport: function () {
                let param;
                let chartData = {title:'',legend:[],xAxis:[],series:[[],[]],chartType:''};
                if(this.sysSourceOpt == 'all') this.sysSourceOpt = '';
                let appSourceCodes = this.sysSourceTabSelected ? this.sysSourceTabSelected : this.sysSourceOpt;
                if(this.chartGroup == 'a' ){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectId:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '单项目数据统计（条）';
                    chartData.chartType = 'bar';
                    api.report_countAlarmReportAThree_request(param).then((res) => {
                        if(res.data.dataArray){
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].alarmYm);
                                chartData.series[0].push(res.data.dataArray[index].countNum);
                            }
                        }                        
                        if(res.data.lastDataArray){
                            for (let index = 0; index < res.data.lastDataArray.length; index++) {
                                chartData.series[1].push(res.data.lastDataArray[index].countNum);
                            }
                        }
                        console.log(chartData);
					    this.drawAlarmSameTimeContrastChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'b'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        projectIds:this.projectIds,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '多项目数据统计（条）';
                    chartData.chartType = 'line';
                    api.report_countAlarmReportBThree_request(param).then((res) => {     
                        if(res.data.dataArray){          
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].alarmYm);
                                chartData.series[0].push(res.data.dataArray[index].countNum);
                            }
                        }
                        console.log(chartData);
					    this.drawAlarmSameTimeContrastChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
                else if(this.chartGroup == 'c'){
                    let param = {
                        appSourceCodes:appSourceCodes,
                        startYm:this.startMonthValue,
                        endYm:this.endMonthValue
                    };
                    chartData.title = '所有项目数据统计（条）';
                    chartData.chartType = 'bar';
                    api.report_countAlarmReportCThree_request(param).then((res) => {  
                        if(res.data.dataArray){                    
                            for (let index = 0; index < res.data.dataArray.length; index++) {
                                chartData.xAxis.push(res.data.dataArray[index].groupName);
                                chartData.series[0].push(res.data.dataArray[index].countNum);
                            }
                        }
                        if(res.data.lastDataArray){
                            for (let index = 0; index < res.data.lastDataArray.length; index++) {
                                chartData.series[1].push(res.data.lastDataArray[index].countNum);
                            }
                        }
                        console.log(chartData);
					    this.drawAlarmSameTimeContrastChart(chartData)
                    }).catch((e) => {
                        console.log(e);
                        tools.error(this,"告警统计数据获取失败");
                    });
                }
            },
            drawCharts() {
                this.fetchCountAlarmReport();
                this.fetchAlarmSameTimeContrastReport();
                this.fetchAlarmUnitAreaReport();
            },
            tabHandleClick(tab, event) {
                this.sysSourceTabSelected = this.sysSourceList[tab.index].code;
                this.drawCharts();
			},
			getSysSourceList: function () {
				let param = {};
				this.listLoading = true;
				api.system_getSysSourceList_request(param).then((res) => {
                    this.sysSourceList = res.data;	
                    this.sysSourceTabSelected = this.sysSourceList[0].code;	
					this.drawCharts();
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
            },
        },
        mounted: function () {
            this.getSysSourceList();
            this.getProjectTree();
        },
        updated: function () {
            
        }
    }
</script>

<style scoped>
    .chart-container {
        width: 100%;
        float: left;
    }
    /* .el-col {
        padding: 30px 20px;
    } */
</style>



// WEBPACK FOOTER //
// history_alarm_charts.vue?c192fbd8